module.exports = __webpack_public_path__ + "static/azubu-logo-07b6399aa90ff8550ec56b61c06373d2.mp4";